import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const VesselIcon: FC<IconProps> = ({ width = 41, height = 18, ...rest }) => (
  <Icon type="Vessel" width={width} height={height} alt="VesselIcon" {...rest} />
)
